<template>
    <!-- 录音播放区域 -->
    <div>
        <audio @canplay="getDuration" controls @timeupdate="updateTime" v-show="false" ref="audio" :src="audioSrc.url" />
        <div class="card" :style="`width:${width};height:${height}`">
            <div class="h4-meeting" v-if="name">{{ audioSrc.fileName }}</div>
            <div class="audioInfo" :class="name ? '' : 'centers'">
                <div class="option">
                    <span class="play" @click="handlePauseOrPlay">
                        <img name="pause" :style="proSty ? 'width:40px' : ''" class="icons" v-show="!paused" ref="pause"
                            src="@/assets/img/stop.svg" alt="">
                        <img name="pause" :style="proSty ? 'width:40px' : ''" class="icons" v-show="paused" ref="pause"
                            src="@/assets/img/play.svg" alt="">
                    </span>
                </div>
                <div class="progress" :class="{ 'bigProgress': proSty }" ref="progress" @click="clickProgress"
                    @mouseup="handleMouseup">
                    <div class="currentProgress" ref="currentProgress">
                        <span class="circle" ref="circle" @mousedown="handleMousedown"></span>
                    </div>
                </div>
                <div class="time">
                    <span class="startTime">{{ currentDuration }}</span>
                    <!-- <span class="endTime">{{ duration }}</span> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "index",
    props: {
        audioSrc: {
            type: Object,
        },
        name: {
            type: Boolean,
            default: true
        },
        backSecond: {
            type: Number,
            default: 3,
        },
        width: {
            type: String,
            default: '300px'
        },
        height: {
            type: String,
        },
        forwardSecond: {
            type: Number,
            default: 10,
        },
        proSty: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            duration: "00:00",
            currentDuration: "00:00",
            audio: "",
            paused: true,
            isMoveIn: false, //是否在移动中
        };
    },
    methods: {
        //后退
        handleBack() {
            if (this.audio.currentTime > this.backSecond) {
                this.audio.currentTime = this.audio.currentTime - this.backSecond;
            }
        },
        //前进
        handleForward() {
            if (this.audio.duration - this.audio.currentTime > this.forwardSecond) {
                this.audio.currentTime = this.audio.currentTime + 10;
            }
        },
        //暂停或播放
        handlePauseOrPlay() {
            this.audio.paused ? this.audio.play() : this.audio.pause();
            this.paused = !this.paused;
        },
        //视频在可以播放时触发
        getDuration() {
            this.duration = this.timeFormat(this.$refs.audio.duration);
            this.audio = this.$refs.audio;
        },
        //将单位为秒的的时间转换成mm:ss的形式
        timeFormat(number) {
            let minute = parseInt(number / 60);
            let second = parseInt(number % 60);
            minute = minute >= 10 ? minute : "0" + minute;
            second = second >= 10 ? second : "0" + second;
            return minute + ":" + second;
        },
        //进度条发生变化时触发
        updateTime() {
            if (!this.$refs.progress) return;
            this.currentDuration = this.timeFormat(this.audio.currentTime);
            //如果不是正在移动 和 没有暂停播放就执行
            if (!this.isMoveIn || !this.audio.paused) {
                // 设置当前时间
                let MoveX =
                    this.$refs.progress.clientWidth *
                    (this.audio.currentTime / this.audio.duration);
                //播放时更新距离
                this.$refs.currentProgress.style.width = MoveX + "px";
                this.$refs.circle.style.left =
                    MoveX - this.$refs.circle.clientWidth / 2 + "px";
            }
        },
        //点击进度条更新进度
        clickProgress(e) {
            //如果不是正在移动 和 没有暂停播放就执行
            if (!this.isMoveIn || !this.audio.paused) {
                this.updateProgress(e.offsetX);
            }
        },
        //更新进度
        updateProgress(MoveX) {
            //当前移动的位置 = 当前移动的位置 / 当前进度条的可视长度    //this.$refs.progress.clientWidth 注意一定要拿总长度 否则会拿进度条已经走过的长度
            let clickProgress = MoveX / this.$refs.progress.clientWidth;
            //设置播放的时间 = 总时长 * 当前点击的长度
            this.audio.currentTime = this.audio.duration * clickProgress;
            //设置移动的位置
            this.$refs.currentProgress.style.width = MoveX + "px";
            this.$refs.circle.style.left =
                MoveX - this.$refs.circle.clientWidth / 2 + "px";
        },
        //鼠标弹起
        handleMouseup() {
            setTimeout(() => {
                this.audio.play();
                this.paused = false;
                this.isMoveIn = false;
            }, 200);
        },
        //小圆圈按下
        handleMousedown() {
            this.audio.pause();
            this.paused = true;
            this.isMoveIn = true;
            let progress = this.$refs.progress;
            //进度条 左 边距离页面左边的距离 移动最小值
            let moveMin = progress.offsetParent.offsetLeft + progress.offsetLeft;
            //进度条 右 边距离页面左边的距离 移动最大值
            let moveMax =
                progress.offsetParent.offsetLeft +
                progress.offsetLeft +
                progress.clientWidth;
            //小圆圈的宽度
            let circleWidth = this.$refs.circle.clientWidth / 2;
            let move = (move) => {
                if (move.pageX >= moveMax) {
                    return;
                } else if (move.pageX <= moveMin) {
                    return;
                }
                this.$refs.circle.style.left =
                    move.pageX - moveMin - circleWidth + "px";
                this.updateProgress(move.pageX - moveMin);
            };
            //获取当前鼠标的位置 X
            document.addEventListener("mousemove", move);
            //鼠标弹起来
            document.addEventListener("mouseup", () => {
                document.removeEventListener("mousemove", move);
            });
        },
    },
};
</script>
<style scoped lang="scss">
.h4-meeting {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; //行数
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
}

.centers {
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.icons {
    width: 25px;
    cursor: pointer;
}

.audioInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 30px;
    width: 100%;
}

.card {
    box-sizing: border-box;
    // box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.03);
    border-radius: 10px;
    position: relative;

    .bigProgress {
        height: 18px !important;
        border-radius: 9px !important;
        width: 80% !important;

        .currentProgress {
            border-radius: 9px !important;

            .circle {
                width: 20px !important;
                height: 20px !important;

                &:hover {
                    width: 20px !important;
                    height: 20px !important;
                }
            }
        }
    }

    .progress {
        height: 10px;
        border-radius: 5px;
        width: 65%;
        background-color: #dadfea;
        cursor: pointer;
        margin: 0 5px 0 10px;

        .currentProgress {
            position: relative;
            height: 100%;
            width: 0;
            background: #1890ff;
            border-radius: 3px;

            .circle {
                position: absolute;
                right: -6px;
                top: -2px;
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                border: 1px solid #3853fe;
                background-color: #fff;

                &:hover {
                    width: 12px;
                    height: 12px;
                    top: -3px;
                    border-radius: 50%;
                }
            }
        }
    }

    .time {
        display: flex;
        justify-content: space-between;
        color: #777a85;
        font-size: 12px;
        margin-right: 5px;
    }

    .option {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0;

        .play,
        .pre,
        .next {
            display: flex;
            padding: 0 2px;
            align-items: center;
            cursor: pointer;
        }
    }
}
</style>